export default __webpack_public_path__ + "static/media/Old_Visa_Logo.b55ca65b.svg";